module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxNiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxsaW5lIHkxPSIxIiB4Mj0iMTYiIHkyPSIxIiBzdHJva2U9IiMyQTMxNEUiIHN0cm9rZS13aWR0aD0iMiIvPg0KPGxpbmUgeTE9IjQuOTAwMzkiIHgyPSI4IiB5Mj0iNC45MDAzOSIgc3Ryb2tlPSIjMkEzMTRFIiBzdHJva2Utd2lkdGg9IjIiLz4NCjxsaW5lIHkxPSI4Ljc5OTgiIHgyPSIxMC40IiB5Mj0iOC43OTk4IiBzdHJva2U9IiMyQTMxNEUiIHN0cm9rZS13aWR0aD0iMiIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/learning/course-content-icon.svg
// module id = 718
// module chunks = 0